export const budgetTypes = [
  { categories: [1, 2, 3, 4], type: "ETCV" },
  { categories: [7], type: "Imagens" },
  { categories: [8], type: "Infusões" },
  { categories: [5], type: "Consulta" },
];
